export const createSiweMessage = ({
  address,
  nonce,
  domain,
  uri,
  chainId,
  statement = 'Sign in to DPIN Prediction Market',
}: {
  address: string;
  nonce: string;
  domain?: string;
  uri?: string;
  chainId?: number;
  statement?: string;
}): string => {
  const d = domain || window.location.host;
  const u = uri || window.location.origin;
  const cid = chainId || Number(import.meta.env.VITE_CHAIN_ID || '56');
  const issuedAt = new Date().toISOString();

  return [
    `${d} wants you to sign in with your Ethereum account:`,
    address,
    '',
    statement,
    '',
    `URI: ${u}`,
    `Version: 1`,
    `Chain ID: ${cid}`,
    `Nonce: ${nonce}`,
    `Issued At: ${issuedAt}`,
  ].join('\n');
};
